<template>
  <div class="container">
    <div class="module-title">
      <span>审核管理 》订单管理</span>
    </div>
    <div class="content">
      <div class="tabs">
        <div class="tabs__item" v-for="(item, index) in tabList" :key="index" @click="changeTab(item.value)" :style="{
          'border-bottom':
            activeName == item.value ? '1px solid #12618A' : 'none',
        }">
          <span>
            {{ item.label }}
          </span>
        </div>
      </div>
      <div class="queryBox">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="下单时间：" prop="date">
            <el-date-picker unlink-panels v-model="formatObj.date1" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品类型：">
            <el-select v-model="postForm.product_type" placeholder="请选择产品类型">
              <el-option v-for="item in options1" :key="item.dictionary_key" :label="item.dictionary_value"
                         :value="item.dictionary_key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号：">
            <el-input v-model="postForm.id" placeholder="请输入订单编号"></el-input>
          </el-form-item>

          <el-form-item class="form-btn">
            <el-button type="primary" size="mini" icon="el-icon-search" @click="search">查询
            </el-button>
            <el-button type="primary" size="mini" icon="el-icon-refresh-left" @click="reset">重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-list">
<!--        企业订单-->
        <el-table ref="refTable" v-if="activeName == 1" :data="tableData" border style="padding-left: 0px"
                  :row-class-name="tableRowClassName" :span-method="objectSpanMethod13"
                  :header-cell-style="{ background: '#eee', color: '#606266' }" :height="'100%'" v-loading="loading"
                  element-loading-text="数据正在加载中">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="title" label="产品信息" min-width="300">
            <template #default="{ row }">
              <div v-if="row.isSpace"></div>
              <div v-else-if="row.isHeader" class="header-cell">
                <div>
                  <div>
                    <span> 创建时间： </span>
                    <span>
                      {{ row.ctm }}
                    </span>
                  </div>
                  <div @click="oper('0', row)">
                    <span> 订单号： </span>
                    <span>
                      <el-button type="text"> {{ row.id }}</el-button>
                      <i class="el-icon-copy-document"></i>
                    </span>
                  </div>
                  <div >
                    <span> 企业名称： </span>
                    <span>
                      <el-button type="text"> {{ row.e_name }}</el-button>
                    </span>
                  </div>
                </div>
                <div>

                  <el-statistic @finish="timeoutFn" format="HH:mm:ss"
                                :value="new Date(row.wtm).getTime() - new Date(row.ntm).getTime() + Date.now()"
                                time-indices
                                v-if="row.status == 1 && (new Date(row.wtm).getTime()) > new Date(row.ntm).getTime()">
                    <template slot="suffix"> 后自动取消</template>
                  </el-statistic>
                  <!-- <span>
                    {{ row.cancel_time }}

                  </span>
                  <span> 后自动取消 </span> -->
                </div>
              </div>
              <div class="info" v-else>
                <div class="img">
                  <img v-if="row.product_type == 'TS200'" src="@/assets/cr_default_payjob.png" alt=""/>
                  <img v-else :src="imgUrl(row.product_image)" alt=""/>
                </div>
                <div class="des">
                  <div class="title font_weight_700 size14">
                    <span v-for="item in options1" :key="item.dictionary_key">
                      <span
                          v-if="item.dictionary_key == row.product_type && row.product_type == 'TS200'">{{ item.dictionary_value }}-{{
                          row.position_name
                        }}</span>
                      <span
                          v-if="item.dictionary_key == row.product_type && row.product_type == 'AI100'">{{ item.dictionary_value }}-{{
                          row.product_name
                        }}</span>
                    </span>
                  </div>
                  <div class="">
                    <span v-if="row.product_type == 'TS200'">{{ row.bidding_enterprise_name }}</span>
                    <div v-else style="display: flex">
                      <span class="begin color7b7b7b">
                        {{ row.package_name }}
                      </span>
                      <div v-for="item in options5" :key="item.dictionary_key">
                        <span v-if="item.dictionary_key == row.activation_type" class="after color7b7b7b">
                          {{ item.dictionary_value }}
                        </span>
                      </div>
                      <span class="span3 color7b7b7b">
                        {{ row.activation_dura }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="order_type" label="订单类型" align="center" min-width="150">
            <template #header>
              <div>
                <el-popover placement="bottom" trigger="click" :width="'fit-content'">
                  <template #reference>
                    <span class="header_title pointer" :class="{
                      color_primary: searchDate.order_type,
                    }">订单类型
                      <i class="iconfont icon-shaixuan2"></i>
                    </span>
                  </template>

                  <div>
                    <el-select v-model="searchDate.order_type" placeholder="请选择" clearable
                               style="margin: 10px 0; width: 150px">
                      <el-option v-for="item in options2" :key="item.dictionary_key" :label="item.dictionary_value"
                                 :value="item.dictionary_key">
                      </el-option>
                    </el-select>
                    <div class="mt" style="text-align: right">
                      <el-button type="text" @click="searchFilter('order_type')" :disabled="!searchDate.order_type">筛选
                      </el-button>
                      <el-button type="text" @click="cancelFilter('order_type')">重置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="{ row }">
              <div v-for="item in options2" :key="item.dictionary_key">
                <span v-if="item.dictionary_key == row.order_type">
                  {{ item.dictionary_value }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="订单状态" align="center" min-width="150">
            <template #header>
              <div>
                <el-popover placement="bottom" trigger="click" :width="'fit-content'">
                  <template #reference>
                    <span class="header_title pointer" :class="{
                      color_primary: searchDate.status,
                    }">订单状态
                      <i class="iconfont icon-shaixuan2"></i>
                    </span>
                  </template>
                  <div>
                    <el-select v-model="searchDate.status" placeholder="请选择" clearable
                               style="margin: 10px 0; width: 150px">
                      <el-option v-for="item in options3" :key="item.dictionary_key" :label="item.dictionary_value"
                                 :value="item.dictionary_key">
                      </el-option>
                    </el-select>
                    <div class="mt" style="text-align: right">
                      <el-button type="text" @click="searchFilter('status')" :disabled="!searchDate.status">筛选
                      </el-button>
                      <el-button type="text" @click="cancelFilter('status')">重置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="{ row }">
              <div v-for="item in options3" :key="item.dictionary_key">
                <p v-if="item.dictionary_key == row.status" class="status">
                  <i class="iconfont icon-kongxinyuanquan size24" :class="[colorClass(item.dictionary_key)]"></i>
                  <span>{{ item.dictionary_value }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="total_amount" label="订单金额(￥)" align="center" min-width="150"></el-table-column>
          <el-table-column prop="payment_amount" label="应付金额(￥)" align="center" min-width="150"></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot="{ row }">
              <div class="btn_column">
<!--                <el-button @click="oper('1', row)" type="text" size="small" v-if="row.status == '1'">支付-->
<!--                </el-button>-->
                <el-button @click="oper('2', row)" type="text" size="small">详情
                </el-button>
<!--                <el-button @click="oper('4', row)" type="text" size="small"-->
<!--                           v-if="(row.status == '3' && row.return_status == true) && row.product_type != 'TS200'">-->
<!--                  退单-->
<!--                </el-button>-->
<!--                <el-button @click="oper('3', row)" type="text" size="small" v-if="row.status == '1'">取消-->
<!--                </el-button>-->
              </div>
            </template>
          </el-table-column>

        </el-table>
<!--        退单审核-->
        <el-table ref="refTable" v-if="activeName == 2" :data="tableData" border style="padding-left: 0px"
                  :row-class-name="tableRowClassName" :span-method="objectSpanMethod3"
                  :header-cell-style="{ background: '#eee', color: '#606266' }" :height="'100%'" v-loading="loading"
                  element-loading-text="数据正在加载中">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="title" label="产品信息" min-width="300">
            <template #default="{ row }">
              <div v-if="row.isSpace"></div>
              <div v-else-if="row.isHeader" class="header-cell">
                <div>
                  <div>
                    <span> 创建时间： </span>
                    <span>
                      {{ row.ctm }}
                    </span>
                  </div>
                  <div @click="oper('0', row)">
                    <span> 订单号： </span>
                    <span>
                      <el-button type="text"> {{ row.id }}</el-button>
                      <i class="el-icon-copy-document"></i>
                    </span>
                  </div>
                  <div >
                    <span> 企业名称： </span>
                    <span>
                      <el-button type="text"> {{ row.hr_order?.e_name }}</el-button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="info" v-else>
                <div class="img">
                  <img :src="imgUrl(row.hr_order.product_image)" alt=""/>
                </div>
                <div class="des">
                  <div class="title font_weight_700 size14">
                    <span v-for="item in options1" :key="item.dictionary_key">
                      <span v-if="item.dictionary_key == row.hr_order.product_type ">{{ item.dictionary_value }}-{{
                          row.hr_order.product_name
                        }}</span>
                    </span>
                  </div>
                  <div class="">
                    <span class="begin color7b7b7b">
                      {{ row.hr_order.package_name }}
                    </span>
                    <div v-for="item in options5" :key="item.dictionary_key">
                      <span v-if="item.dictionary_key == row.hr_order.activation_type" class="after color7b7b7b">
                        {{ item.dictionary_value }}
                      </span>
                    </div>
                    <span class="span3 color7b7b7b">
                      {{ row.hr_order.activation_dura }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="order_type" label="订单类型" align="center" min-width="150">
            <template #header>
              <div>
                <el-popover placement="bottom" trigger="click" :width="'fit-content'">
                  <template #reference>
                    <span class="header_title pointer" :class="{
                      color_primary: searchDate.order_type,
                    }">订单类型
                      <i class="iconfont icon-shaixuan2"></i>
                    </span>
                  </template>

                  <div>
                    <el-select v-model="searchDate.order_type" placeholder="请选择" clearable
                               style="margin: 10px 0; width: 150px">
                      <el-option v-for="item in options2" :key="item.dictionary_key" :label="item.dictionary_value"
                                 :value="item.dictionary_key">
                      </el-option>
                    </el-select>
                    <div class="mt" style="text-align: right">
                      <el-button type="text" @click="searchFilter('order_type')" :disabled="!searchDate.order_type">筛选
                      </el-button>
                      <el-button type="text" @click="cancelFilter('order_type')">重置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="{ row }">
              <div v-for="item in options2" :key="item.dictionary_key">
                <span v-if="item.dictionary_key == row.hr_order.order_type">
                  {{ item.dictionary_value }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="退单状态" align="center" min-width="150">
            <template #header>
              <div>
                <el-popover placement="bottom" trigger="click" :width="'fit-content'">
                  <template #reference>
                    <span class="header_title pointer" :class="{
                      color_primary: searchDate.approval_status,
                    }">退单状态
                      <i class="iconfont icon-shaixuan2"></i>
                    </span>
                  </template>
                  <div>
                    <el-select v-model="searchDate.approval_status" placeholder="请选择" clearable
                               style="margin: 10px 0; width: 150px">
                      <el-option v-for="item in options10" :key="item.dictionary_key" :label="item.dictionary_value"
                                 :value="item.dictionary_key">
                      </el-option>
                    </el-select>
                    <div class="mt" style="text-align: right">
                      <el-button type="text" @click="searchFilter('approval_status')"
                                 :disabled="!searchDate.approval_status">筛选
                      </el-button>
                      <el-button type="text" @click="cancelFilter('approval_status')">重置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="{ row }">
              <div v-for="item in options10" :key="item.dictionary_key">
                <p v-if="item.dictionary_key == row.approval_status" class="status">
                  <i class="iconfont icon-kongxinyuanquan size24" :class="[colorClass(item.dictionary_key)]"></i>
                  <span>{{ item.dictionary_value }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payment_amount" label="订单金额(￥)" align="center" min-width="200">
            <template slot-scope="{row}">{{ row.hr_order.payment_amount }}</template>
          </el-table-column>
          <el-table-column prop="refund_amount" label="应退金额(￥)" align="center" min-width="200"></el-table-column>
          <el-table-column prop="refund_reason" label="退单原因" align="center" min-width="200" max-width="300" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot="{ row }">
              <div class="btn_column">
                <el-button @click="oper('9', row)" type="text" size="small">详情
                </el-button>
                <el-button @click="oper('10', row)" type="text" size="small" :disabled="row.approval_status != '1'">审核
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
<!--        人才订单-->
        <el-table ref="refTable" v-if="activeName == 3" :data="tableData" border style="padding-left: 0px"
                  :row-class-name="tableRowClassName" :span-method="objectSpanMethod2"
                  :header-cell-style="{ background: '#eee', color: '#606266' }" :height="'100%'" v-loading="loading"
                  element-loading-text="数据正在加载中">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="title" label="产品信息" min-width="300">
            <template #default="{ row }">
              <div v-if="row.isSpace"></div>
              <div v-else-if="row.isHeader" class="header-cell">
                <div>
                  <div>
                    <span> 创建时间： </span>
                    <span>
                      {{ row.ctm }}
                    </span>
                  </div>
                  <div @click="oper('0', row)">
                    <span> 订单号： </span>
                    <span>
                      <el-button type="text"> {{ row.id }}</el-button>
                      <i class="el-icon-copy-document"></i>
                    </span>
                  </div>
                </div>
                <div>
                  <span>
                    {{ row.expiration_date_str }}
                  </span>
                  <span> 到期自动停止服务 </span>
                </div>
              </div>
              <div class="info" v-else>
                <div class="img">
                  <img :src="imgUrl(row.product_image)" alt=""/>
                </div>
                <div class="des">
                  <div class="title font_weight_700 size14">
                    <span v-for="item in options1" :key="item.dictionary_key">
                      <span
                          v-if="item.dictionary_key == row.product_type && row.product_type == 'TS200'">{{ item.dictionary_value }}-{{
                          row.position_name
                        }}</span>
                      <span
                          v-if="item.dictionary_key == row.product_type && row.product_type == 'AI100'">{{ item.dictionary_value }}-{{
                          row.product_name
                        }}</span>
                    </span>
                  </div>
                  <div class="">
                    <span class="begin color7b7b7b">
                      {{ row.package_name }}
                    </span>
                    <div v-for="item in options5" :key="item.dictionary_key">
                      <span v-if="item.dictionary_key == row.activation_type" class="after color7b7b7b">
                        {{ item.dictionary_value }}
                      </span>
                    </div>
                    <span class="span3 color7b7b7b">
                      {{ row.activation_dura }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="order_type" label="到期时间" align="center" min-width="150">
            <template slot-scope="{ row }">
              <span class="colorRed">{{ row.expiration_date_str }}</span>
            </template>
          </el-table-column>

          <!--          <el-table-column prop="status" label="运行状态" align="center" width="200">-->
          <!--            <template slot-scope="{ row }">-->
          <!--              <div v-for="item in options4" :key="item.dictionary_key">-->
          <!--                <p v-if="item.dictionary_key == row.status" class="status">-->
          <!--                  <span>{{ item.dictionary_value }}</span>-->
          <!--                  <i class="margin_left_5 iconfont size16" :class="[fontColorClass(item.dictionary_key)]"></i>-->
          <!--                </p>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column label="是否自动续费" align="center" min-width="150">
            <template slot-scope="{ row }">
              <span v-if="row['auto_renew'] == 1">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="payment_amount" label="订单金额(￥)" align="center" min-width="150"></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot="{ row }">

              <div class="btn_column">
                <!--                <el-button @click="oper('5', row)" type="text" size="small" :disabled="!row.renewalFlag">续费</el-button>-->
<!--                <el-button :loading="renewalLoading" @click="oper('5', row)" type="text" size="small">续费&#45;&#45;调试</el-button>-->
<!--                <el-button @click="oper('6', row)" type="text" size="small">升级</el-button>-->
<!--                <el-button @click="oper('7', row)" type="text" size="small">详情</el-button>-->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="cr_footer">
      <div class="footer_left">
        <i class="el-icon-place"></i>
        <div id="box">
          <ul id="con1" :class="{ anim: animate == true }">
            <li v-for="item in items" :key="item.name">{{ item.name }}</li>
          </ul>
        </div>
      </div>
      <div class="footer_right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 30]" :page-size="pagesize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!--我的订单支付-->
    <el-dialog :visible.sync="dialogVisible" width="350px" :before-close="handleClose" :modal-append-to-body="false">
      <template slot="title">
        <span>
          {{ dialogInfo.title }}
        </span>
        <span class="color_red"> ￥{{ payInfo.payment_amount }} </span>
      </template>
      <div class="qrBox">
        <div class="qrcode">
          <qrcode ref="qrcode" :src="qrSrc" :options="{
            width: 200,
            height: 200,
          }"/>
          <div class="overtime" v-if="overtimeShow">
            <p>支付超时关闭</p>
          </div>
        </div>
        <div class="tips">
          <span class="size16 padding_5 color_red">
            {{ dialogInfo.tips }}
          </span>
          <div class="time padding_5">
            <span>请在</span>
            <el-statistic ref="statistic" @finish="finish" format="HH:mm:ss" :value="endTime" time-indices>
            </el-statistic>
            <span>完成付款</span>
          </div>
        </div>

        <div class="method">
          <div class="record after pointer" :class="{
            color_primary: payMethod == 'ALIPAY_TRANSFER',
          }" @click="changePayMethod('ALIPAY_TRANSFER')">
            支付宝
          </div>
          <div class="record pointer" :class="{
            color_primary: payMethod == 'WECHAT_PAY',
          }" @click="changePayMethod('WECHAT_PAY')">
            微信
          </div>
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
    </el-dialog>
    <!--我的订单发起退单-->
    <el-dialog v-dialogDrag title="退单确认" :visible.sync="refundDialogVisible" width="550px"
               :modal-append-to-body="false">
      <el-form :model="refundForm" :rules="refundRules" ref="refundFormModel" label-width="100px">
        <el-form-item label="订单编号：">
          <!--          <el-input v-model="refundOrder.id" disabled></el-input>-->
          <span>{{ refundOrder.id }}</span>
        </el-form-item>
        <!--        <el-form-item label="订单试用期限：">-->
        <!--          <el-select v-model="refundOrder.on_trial" style="width:100%" disabled>-->
        <!--            <el-option v-for="item in options7" :key="item.dictionary_key" :label="item.dictionary_value"-->
        <!--                       :value="item.dictionary_key">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="订单退款期限：">-->
        <!--          <el-select v-model="refundOrder.return_deadline" style="width:100%" disabled>-->
        <!--            <el-option v-for="item in options8" :key="item.dictionary_key" :label="item.dictionary_value"-->
        <!--                       :value="item.dictionary_key">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item label="退款金额：" prop="refund_amount">
          <span>{{ refundForm.refund_amount }}元</span>
        </el-form-item>
        <el-form-item label="退款方式：" prop="refund_method">
          <el-select v-model="refundForm.refund_method" placeholder="请选择退款方式" style="width:100%">
            <el-option v-for="item in options9.filter((item) => item.hide == 1)" :key="item.dictionary_key"
                       :label="item.dictionary_value" :value="item.dictionary_key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退单原因：" prop="refund_reason">
          <el-select v-model="refundForm.refund_reason" placeholder="请选择退单原因" style="width:100%">
            <el-option v-for="item in options6" :key="item.dictionary_value" :label="item.dictionary_value"
                       :value="item.dictionary_value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRefund">确 定</el-button>
      </span>
    </el-dialog>
    <!--可续费订单续费下单支付-->
    <el-dialog v-dialogDrag :title="dialogRenewalTitle" :visible.sync="dialogRenewalPay.val"
               :modal-append-to-body="false"
               v-if="dialogRenewalPay.val" center :width="dialogRenewalWidth">
      <!-- v-if  从新渲染 -->
      <pay :dialog="dialogRenewalPay" v-on:parentFn="onRenewalSubmit" v-if="dialogRenewalPay.val"
           :editObj="renewalObj" :original_order="original_order" :is_renewal="true"
           @confirmOrderToPay="changeDialogWidth">
      </pay>
    </el-dialog>

    <!--订单详情-->
    <el-dialog v-dialogDrag title="订单详情" :visible.sync="dialogDetail.val" :modal-append-to-body="false" :width="detailWidth"
               v-if="dialogDetail.val" center>
      <!-- v-if  从新渲染 -->
      <detail :dialog="dialogDetail" v-if="dialogDetail.val" :orderId="detailOrderId" :refundOrder="refundOrderDetail">
      </detail>
    </el-dialog>

    <!--退单审核-->
    <el-dialog v-dialogDrag title="退单审核" :visible.sync="dialogApproval.val" :modal-append-to-body="false" width="800px"
               v-if="dialogApproval.val" center>
      <!-- v-if  从新渲染 -->
      <approval
          v-if="dialogApproval.val"
          :dialog="dialogApproval"
          :orderId="detailOrderId"
          :refundOrder="refundOrderDetail"
          @updateRefundList="getList">
      </approval>
    </el-dialog>
  </div>
</template>

<script>
import qrcode from "@/components/common/qrcode.vue";
import pay from '@/components/orderManagement/pay.vue'
import detail from '@/components/review/orderReview/detail.vue'
import approval from '@/components/review/orderReview/approval.vue'

//支付接口 orderWebAlipay
export default {
  components: {
    qrcode, pay, detail,approval
  },
  data() {
    return {
      dialogVisible: false,
      refundDialogVisible: false,
      timer: null,
      animate: false,
      items: [
        {
          name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200120）注册数剧等等",
        },
        {
          name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200122）注册数剧等等",
        },
        {
          name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200123）注册数剧等等",
        },
      ],
      options1: [], //产品类型
      options2: [], //订单类型
      options3: [], //订单状态
      options4: [], //运行状态
      options5: [], //销售类型
      options6: [],//退单原因
      options7: [],//产品试用期限
      options8: [],//产品退款期限
      options9: [],//产品退款方式
      options10: [],//退单审核状态
      searchDate: {
        order_type: "",
        status: "",
      },
      // tab切换
      tabList: [
        {
          label: "企业订单",
          value: "1",
        },
        {
          label: "企业退单",
          value: "2",
        },
        {
          label: "人才订单",
          value: "3",
        },
      ],
      //
      tableType: "1",
      activeName: "1",
      // 搜索区域
      formatObj: {
        date1: [],
      },
      postForm: {
        page: 1,
        limit: 10,
        start_time: "",
        end_time: "",
        product_type: "",
        order_number: "",
        order_type: "", // 订单类型
        status: "", // 订单状态
      },
      // 分页
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      // 表格数据
      tableData: [],
      // 二维码
      qrSrc: "",
      //   订单号
      order_number: "",
      maxReconnectAttempts: 5, //最大重连次数
      reconnectAttempts: 0, //当前重连次数
      eventSource: null, //sse
      payMethod: "",
      dialogInfo: {
        title: "支付宝扫码",
        tips: "打开支付宝扫一扫完成支付",
      },
      payInfo: {},
      payTimmer: null,
      endTime: null, //倒计时
      overtimeShow: false, //超时显示


      //  退单
      refundOrder: {},
      refundForm: {},
      refundRules: {
        refund_reason: [{required: true, message: '请选择退单原因', trigger: 'blur'}],
        refund_method: [{required: true, message: '请选择退款方式', trigger: 'blur'}],
      },

      //续费订单
      dialogRenewalPay: {val: false},
      dialogRenewalWidth: '500px',
      dialogRenewalTitle: '',
      original_order: {},
      renewalLoading: false,
      renewalObj: {},

      //订单详情
      dialogDetail: {val: false},
      detailOrderId: '',
      refundOrderDetail: {},
      detailWidth:'550px',

      //  退单审核
      dialogApproval:{val: false},
    };
  },
  mounted() {
    this.timer = setInterval(this.scroll, 2000);
    this.getList();
    this.options1 = this.getDictsData("PM-COMPANY-CPLX", "options1");
    this.options2 = this.getDictsData("PM-COMPANY-DDLX", "options2");
    this.options3 = this.getDictsData("PM-COMPANY-DDZT", "options3");
    this.options4 = this.getDictsData("PM-COMPANY-YXZT", "options4");
    this.options5 = this.getDictsData("PM-COMPANY-XSLX", "options5");
    this.options6 = this.getDictsData("TDGL-TDYY", "options6");
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.payTimmer);
    this.payTimmer = null;
    this.eventSource && this.eventSource.close();
    this.eventSource = null;
  },
  computed: {
    imgUrl() {
      return function (url) {
        return `/api/common/files${url}`;
      };
    },
    colorClass() {
      return function (key) {
        switch (key) {
          case "1":
          case "2":
            return "color_red";
            break;
          case "3":
          case "4":
            return "color_green";
            break;
          case "5":
          case "6":
            return "color_yellow";
            break;
          default:
            break;
        }
        // return url ? 'dot' : ''
      };
    },
    fontColorClass() {
      return function (key) {
        switch (key) {
          case "1":
            return "icon-yunhang1 color_green";
          case "2":
            return "icon-stop-circle color_gray";
            break;
          default:
            break;
        }
      };
    },
  },

  methods: {
    searchFilter(property) {
      this.postForm[property] = this.searchDate[property];
      this.getList();
    },
    cancelFilter(property) {
      this.searchDate[property] = "";
      this.postForm[property] = this.searchDate[property];
      this.getList();
    },
    // 获取数据字典值
    async getDictsData(dict, optionsNmae) {
      let options = [];
      await this.$tools
          .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
            data: {
              dictionary_code: dict,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              options = res.data.data.dictionary_detail;
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      this[optionsNmae] = options;
    },
    scroll() {
      let con = document.getElementById("con1");
      con.style.marginTop = "-34px";
      this.animate = !this.animate;
      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(function () {
        that.items.push(that.items[0]);
        that.items.shift();
        con.style.marginTop = "0px";
        that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
        this.timer = null;
      }, 1000);
    },
    changeTab(value) {
      this.activeName = value;
      if(value == '2'){
        this.searchDate.approval_status='1'
        this.postForm.approval_status='1'
      }else{
        this.searchDate.approval_status=''
        this.postForm.approval_status=''
      }
      this.getList();
    },
    getList() {
      this.tableData = []
      this.loading = true;
      this.postForm.page = this.currentPage;
      this.postForm.limit = this.pagesize;
      let formaterFileds = {
        start_time: (this.formatObj.date1 && this.formatObj.date1.length) ? this.formatObj.date1[0] : "",
        end_time: (this.formatObj.date1 && this.formatObj.date1.length) ? this.formatObj.date1[1] : ""
      };
      let url = "";
      switch (this.activeName) {
        case "1":
          url = this.$baseUrl.orderList;
          formaterFileds.order_role = '2'
          break;
        case "2":
          url = this.$baseUrl.refundList;
          this.getDictsData("TDGL-SPZT", "options10");
          formaterFileds.order_id = this.postForm.id
          break;
        case "3":
          url = this.$baseUrl.orderList;
          formaterFileds.activation_type = '1'
          formaterFileds.status = '3'
          formaterFileds.order_role = '1'
          break;
        default:
          break;
      }

      this.$tools
          .asyncPost(this, url, {
            data: Object.assign({}, this.postForm, formaterFileds),
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.tableData = res.data.data.data;
              this.tableData = this.tableData.flatMap((item) => [
                {isSpace: true, id: `space_${item.id}`},
                {isHeader: true, id: `header_${item.id}`, ...item}, // 标题行
                {...item, isHeader: false}, // 数据行
              ]);
              if (this.activeName == '2') {
                this.tableData.forEach(async item => {
                  item.renewalFlag = await this.checkExpirationReminder(new Date(item.expiration_date_str), new Date(item.ntm), item.activation_dura?.slice(0, -2))
                })
              }
              this.total = res.data.data.total;
              this.$nextTick(() => {
                this.$refs.refTable.doLayout(); //重新渲染表格
              });
            } else {
              this.$message({type: "error", message: res.data.msg});
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
    },
    handleSizeChange(val) {
      this.pagesize = val; //每页下拉显示数据
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val; //点击第几页
      this.getList();
    },
    search() {
      // console.log(value);
      // this.postForm1.enterprise_id = value
      this.currentPage = 1;

      this.getList();
    },
    // 重置
    reset() {
      let obj = {
        start_time: "",
        end_time: "",
        product_type: "",
        order_number: "",
        id: ''
      };
      Object.keys(obj).forEach((key) => {
        this.postForm[key] = obj[key];
      });
      this.formatObj.date1 = [];

      this.currentPage = 1;
      // this.pagesize = 10;
      this.getList();
    },
    // 表格-合并行1、3
    objectSpanMethod13({row, columnIndex}) {
      if (row.isSpace) {

        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 6}
            break;
            // case 5:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;
        }


      }
      if (row.isHeader) {
        // console.log(columnIndex,'columnIndex');

        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 6}
            break;
            // case 5:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;
        }

        // return columnIndex === 0
        //   ? { rowspan: 1, colspan: this.activeName=='2'?4 :5  } // 首列合并所有列
        //   : { rowspan: 0, colspan: 0 }; // 其他列隐藏
      }
      return {rowspan: 1, colspan: 1}; // 数据行正常显示
    },
    objectSpanMethod3({row, columnIndex}) {
      if (row.isSpace) {

        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 7}
            break;
            // case 5:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;
        }


      }
      if (row.isHeader) {
        // console.log(columnIndex,'columnIndex');

        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 7}
            break;
            // case 5:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;
        }

        // return columnIndex === 0
        //   ? { rowspan: 1, colspan: this.activeName=='2'?4 :5  } // 首列合并所有列
        //   : { rowspan: 0, colspan: 0 }; // 其他列隐藏
      }
      return {rowspan: 1, colspan: 1}; // 数据行正常显示
    },
    objectSpanMethod2({row, columnIndex}) {
      if (row.isSpace) {
        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 5}
            break;
            // case 4:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;

        }
      }
      if (row.isHeader) {

        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 5}
            break;
            // case 4:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;
        }
        // return columnIndex === 0
        //   ? { rowspan: 1, colspan: this.activeName=='2'?4 :5  } // 首列合并所有列
        //   : { rowspan: 0, colspan: 0 }; // 其他列隐藏
      }
      return {rowspan: 1, colspan: 1}; // 数据行正常显示
    },
    // 行类名，用来修改颜色
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 3 == 0) {
        return "space-row";
      } else if (rowIndex % 3 == 1) {
        return "header-row";
      }
      return "";
    },
    async oper(type, row) {
      switch (type) {
        case "0": //复制订单
          const el = document.createElement("input");
          el.value = row.id;
          el.style.position = "fixed"; // 避免页面滚动
          document.body.appendChild(el);
          el.select();
          const success = document.execCommand("copy");
          try {
            if (success) {
              this.$message({
                showClose: true,
                message: "复制成功",
                type: "success",
              });
            } else {
              console.error("复制失败");
            }
          } catch (error) {
            console.error("复制失败:", err);
          } finally {
            document.body.removeChild(el);
          }

          // navigator.clipboard.writeText(row.order_number)
          //     .then(() => this.$message({
          //         showClose: true,
          //         message: '复制成功',
          //         type: 'success'
          //     }))
          //     .catch(err => console.error("复制失败：", err));
          break;
        case "1": //我的订单支付
          this.payInfo = {};
          this.payInfo = row;
          this.payMethod = '';
          this.changePayMethod("ALIPAY_TRANSFER");

          // this.$MessageBox.confirm('确定要删除吗?', '提示', {
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消',
          //     type: 'warning'
          // }).then(() => {
          //     this.$tools
          //         .asyncPost(
          //             this,
          //             this.$baseUrl.applyforDel, {
          //             data: {
          //                 ids: [row.id]
          //             }
          //         }).then((res) => {
          //             if (res.data.code == 0) {
          //                 this.$message({
          //                     type: "success",
          //                     message: "删除成功!",
          //                 });
          //                 this.onSubmit();
          //             } else {
          //                 this.$message({ type: "error", message: res.data.msg });
          //             }

          //         }).catch((err) => { });
          // })
          break;
        case "2": //我的订单订单详情
        case "7":
        case "9":
          this.dialogDetail.val = true
          this.detailOrderId = row.id
          this.refundOrderDetail = type == '9' ? row : {}
          this.detailWidth = type == '9'?'800px':'550px'
          break;
        case "3": //我的订单取消订单
          this.$MessageBox
              .confirm("确定要取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.orderCancel, {
                      data: {
                        id: row.id,
                        order_role: JSON.parse(localStorage.getItem('useritem')).acctype
                      },
                    })
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message({
                          type: "success",
                          message: "取消成功!",
                        });
                        this.getList();
                      } else {
                        this.$message({type: "error", message: res.data.msg});
                      }
                    })
                    .catch((err) => {
                    });
              });
          break;
        case "4": //我的订单退单
          this.checkTD(row)
          break;
        case "5": //续费订单续费
          this.toRenewal(row)
          break;
        case "6": //续费订单升级
          break;
        case "8": //退单删除订单--已拒绝
          this.$MessageBox
              .confirm("确定要删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.refundDel, {
                      data: {
                        ids: [row.id],
                      },
                    })
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message({
                          type: "success",
                          message: "删除成功!",
                        });
                        this.getList();
                      } else {
                        this.$message({type: "error", message: res.data.msg});
                      }
                    })
                    .catch((err) => {
                    });
              });
          break;
        case "10": //退单审核
          this.dialogApproval.val = true
          this.detailOrderId = row.id
          this.refundOrderDetail = row
          break;
        default:
          break;
      }
    },

    //退单
    //检测订单时候可退单
    checkTD(order) {
      this.$tools
          .asyncPost(this, this.$baseUrl.orderGet, {
            data: {
              id: order.id,
              order_role: JSON.parse(localStorage.getItem('useritem')).acctype
            }
          }).then(res => {
        if (res.data.code == 0) {
          if (res.data.data.return_status) {
            this.setRefundForm(order)
          } else {
            this.$message({
              type: "error",
              message: "不可退单!",
            });
          }
        }
      })
    },
    /**
     * 计算退款金额（退款期限从试用期结束后开始计算）
     * @param {number} totalAmount - 订单总金额
     * @param {Date} purchaseDate - 购买日期
     * @param {Date} currentDate - 当前日期（申请退款日期）
     * @param {string} trialPeriod - 试用期（"7天" | "15天" | "1个月" | "3个月"）
     * @returns {number} 应退款金额
     */
    calculateRefund(totalAmount, purchaseDate, currentDate, trialPeriod) {
      // 计算试用期结束日期
      const trialEndDate = new Date(purchaseDate);
      if (trialPeriod.endsWith('天')) {
        trialEndDate.setDate(trialEndDate.getDate() + parseInt(trialPeriod.slice(0, -1)));
      } else if (trialPeriod.endsWith('月')) {
        trialEndDate.setMonth(trialEndDate.getMonth() + parseInt(trialPeriod.slice(0, -1)));
      } else {
        throw new Error("试用期参数错误");
      }

      // 当前日期如果在试用期内 → 全额退款
      if (currentDate <= trialEndDate) {
        return totalAmount;
      }

      // 试用期结束后，计算已过天数
      const daysAfterTrial = Math.floor((currentDate - trialEndDate) / (1000 * 60 * 60 * 24));

      // 试用期结束后7天内 → 仍可全额退款
      if (daysAfterTrial <= 7) {
        return totalAmount;
      }

      // 超过7天：按使用月份扣费（不足1个月算1个月）
      const usedMonths = Math.ceil(daysAfterTrial / 30);
      const monthlyDeduction = totalAmount / 12; // 假设按年购买，否则需调整计算方式
      const deduction = Math.min(usedMonths * monthlyDeduction, totalAmount);

      return Math.max(0, totalAmount - deduction);
    },
    //初始化退款表单
    async setRefundForm(order) {
      this.refundForm = {}
      this.refundOrder = {}
      await this.getDictsData("PM-CORERIVER-SYQX", "options7");
      await this.getDictsData("PM-CORERIVER-THQX", "options8");
      await this.getDictsData("TDGL-TDFS", "options9");
      this.refundOrder = order

      //获取试用期限
      let trialPeriod = ''
      this.options7.forEach(item => {
        if (item.dictionary_key == order.on_trial) {
          trialPeriod = item.dictionary_value.slice(0, -3)
        }
      })
      this.refundForm.refund_amount = this.calculateRefund(order.payment_amount, new Date(order.ctm), new Date(), trialPeriod)
      this.refundDialogVisible = true
    },
    submitRefund() {
      this.$refs["refundFormModel"].validate((valid) => {
        if (valid) {
          let tmpform = {
            refund_reason: this.refundForm.refund_reason,
            refund_amount: this.refundForm.refund_amount,
            order_id: this.refundOrder.id,
            user_id: this.refundOrder.user_id,
            refund_method: this.refundForm.refund_method,
            product_type: this.refundOrder.product_type,
            order_role: JSON.parse(localStorage.getItem('useritem')).acctype,
            approval_comment: ''
          }
          this.$tools
              .asyncPost(this, this.$baseUrl.refundAdd, {
                data: tmpform
              }).then(res => {
            if (res.data.code == 0) {
              this.refundDialogVisible = false
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.getList()
            }
          })
        }
      })
    },

    detail(row) {
      console.log(row);
      // this.$router.push({
      //     path: "/index/accessDetail",
      //     query: {
      //         id: row.id,
      //         type: 'access'
      //     }
      // });
    },

    //我的订单支付
    // 二维码
    handleClose(done) {
      this.dialogVisible = false;
      clearInterval(this.payTimmer);
      this.payTimmer = null;
      this.eventSource && this.eventSource.close();
      this.eventSource = null;
      this.overtimeShow = false;
      this.payMethod = "";
      this.qrSrc = "";
      this.order_number = "";
    },
    timerFn() {
      this.endTime--;
      // console.log(this.endTime, 'endTime');
    },
    connectSSE() {
      this.eventSource = new EventSource(
          this.$baseUrl.getWebPayStatusSse + `?order_no=${this.order_number}` + '&order_role=' + JSON.parse(localStorage.getItem('useritem')).acctype
      );

      this.eventSource.onopen = () => {
        console.log("SSE连接已建立");
        this.reconnectAttempts = 0; // 重置重连计数器
      };

      this.eventSource.onmessage = (e) => {
        console.log("收到消息:", e.data);
        // 处理消息逻辑
      };
      this.eventSource.addEventListener("ok", (e) => {
        console.log("收到消息:", e.data);
        if (
            e.data.indexOf("SUCCESS") !== -1 &&
            e.data.indexOf(this.order_number) !== -1
        ) {
          this.paySuccess();
          this.eventSource.close();
        }
      });

      this.eventSource.onerror = () => {
        if (this.eventSource.readyState === EventSource.CLOSED) {
          console.log("连接已关闭");
        }

        // 渐进式重连
        const delay = Math.min(
            1000 * Math.pow(2, this.reconnectAttempts),
            30000
        );
        this.reconnectAttempts++;

        if (this.reconnectAttempts <= this.maxReconnectAttempts) {
          console.log(
              `尝试重新连接 (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`
          );
          setTimeout(() => this.connectSSE(), delay);
        } else {
          console.error("达到最大重连次数");
        }
      };
    },
    // 支付成功
    paySuccess() {
      this.$message({
        type: "success",
        message: "支付成功!",
      });
      this.handleClose();
      this.getList();
    },
    finish() {
      clearInterval(this.payTimmer);
      this.payTimmer = null;
      this.overtimeShow = true;
      this.eventSource && this.eventSource.close();
      this.eventSource = null;
    },
    timeoutFn() {
      this.getList();
    },
    changePayMethod(method) {
      // 如果点击的方式没变化并且没有超时，则不进行任何操作
      if (this.payMethod == method && !this.overtimeShow) {
        return;
      }
      clearInterval(this.payTimmer);
      this.payTimmer = null;
      this.eventSource && this.eventSource.close();
      this.eventSource = null;
      this.payMethod = method;
      if (this.$refs.statistic) {
        this.$refs.statistic.suspend(true); // 暂停定时器
      }

      let route = "paybyAlipay";
      switch (method) {
        case "ALIPAY_TRANSFER":
          route = "paybyAlipay";
          this.dialogInfo.title = "支付宝扫码";
          this.dialogInfo.tips = "打开支付宝扫一扫完成支付";
          break;
        case "WECHAT_PAY":
          route = "weChatPay";
          this.dialogInfo.title = "微信扫码";
          this.dialogInfo.tips = "打开微信扫一扫完成支付";
        default:
          break;
      }
      this.$tools
          .asyncPost(this, this.$baseUrl.orderWebAlipay, {
            data: {
              id: this.payInfo.id,
              user_id: this.payInfo.user_id,
              product_code: this.payInfo.product_code,
              product_name: this.payInfo.product_name,
              package_code: this.payInfo.package_code,
                method: "scan",
              order_role: JSON.parse(localStorage.getItem('useritem')).acctype
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              console.log(res.data.data, "res.data.data");
              let info = res.data.data;
              this.qrSrc = info.pay_url;
              this.order_number = info.order_number;
              console.log(this.qrSrc, "qrSrc");
              // 轮询：系统到期时间-系统当前时间+ 当前时间
              this.endTime =
                  new Date(info.wtm).getTime() - new Date(info.ntm).getTime() + Date.now();
              this.dialogVisible = true;
              this.$nextTick(() => {
                this.$refs.qrcode.init();
                this.overtimeShow = false;
                this.$refs.statistic.suspend(false); // 开始倒计时
                this.payTimmer = setInterval(this.timerFn, 1000);
                this.connectSSE();
              });
            } else {
              this.$message({type: "error", message: res.data.msg});
            }
          })
          .catch((err) => {
          });
    },

    //续费订单
    //  判断当前订单是否可以续费
    /**
     * 检查当前时间是否在订单到期前的特定时间内
     * @param {Date} expireTime 订单到期时间
     * @param {Date} currentTime 当前时间
     * @param {number} validityPeriod 有效期（以月为单位）
     * @returns {boolean} 是否在提醒时间内
     */
    checkExpirationReminder(expireTime, currentTime, validityPeriod) {
      // 计算剩余时间（毫秒）
      const remainingTime = expireTime.getTime() - currentTime.getTime();

      // 将剩余时间转换为天数
      const remainingDays = remainingTime / (1000 * 60 * 60 * 24);

      if (validityPeriod <= 1) {
        // 有效期为1个月或更短时，15天内返回true
        return remainingDays <= 15 && remainingDays >= 0;
      } else {
        // 有效期大于1个月时，30天内返回true
        return remainingDays <= 30 && remainingDays >= 0;
      }
    },
    //续费下单
    async toRenewal(row) {
      this.renewalLoading = true
      this.dialogRenewalWidth = '500px'

      //组装续费订单产品及套餐信息
      let {pro, pack} = await this.getRenewalProDetail(row.product_id, row.package_code)
      if (Object.keys(pack).length == 0) {
        this.$message({type: "error", message: '当前套餐已下架，请选择其他产品进行购买！'});
        this.renewalLoading = false
        return
      }
      this.renewalObj = {
        pro: pro,
        pack: pack,
      };
      this.original_order = {
        original_order_id: row.id,
        original_order_number: row.order_number
      }
      this.dialogRenewalPay.val = true
      this.dialogRenewalTitle = '续费支付'
      this.renewalLoading = false
    },
    //获取续费产品详情
    async getRenewalProDetail(productId, packageCode) {
      let that = this
      let pro = {}
      let pack = {}
      await this.$tools
          .asyncPost(this, this.$baseUrl.hrproductGet, {
            data: {
              id: productId,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              pro = res.data.data
              //组装产品
              if (pro.hr_packages != null) {
                pack = pro.hr_packages.find(item => item.package_code = packageCode)
                //组装套餐
                pack.num = 1
                pack.unit = '2'
                //计算折扣价
                if (pack.package_discount === '1.00' && pack.discount_start === '' && pack.discount_end === '') {
                  pack.isInDeadline = false
                } else {
                  pack.isInDeadline = pack.discount_start == '' ? true : that.isCurrentTimeInDateRange(pack.discount_start, pack.discount_end)
                  let tmpPrice = pack.package_price * parseFloat(pack.package_discount)
                  if (tmpPrice < 0.01) {
                    pack.deadlinePrice = 0.01
                  } else {
                    pack.deadlinePrice = pack.package_price * parseFloat(pack.package_discount)
                  }
                }
                pack.total = pack.isInDeadline ? pack.deadlinePrice : pack.package_price
                //  单价单位  次还是月
                this.options5.forEach(item => {
                  if (pack.sales_type == item.dictionary_key) {
                    pack.singleUnit = item.dictionary_describe
                    pack.unit = pack.singleUnit == '次' ? '次' : '2'
                  }
                })

              } else {
                pro.hr_packages = []
              }
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      return {'pro': pro, 'pack': pack}
    },
    //续费订单支付
    onRenewalSubmit(type) {
      if (type == 'pay') {
        this.dialogRenewalPay.val = true
        this.dialogRenewalTitle = '支付结果'
      } else {
        this.dialogRenewalPay.val = false
      }
    },
    //根据下单及支付状态设置弹窗宽度
    changeDialogWidth() {
      this.dialogRenewalWidth = '920px'
    },
    isCurrentTimeInDateRange(startDate, endDate) {
      // 获取当前时间
      const now = new Date();

      // 如果startDate是字符串，则转换为Date对象
      const start = typeof startDate === 'string' ? new Date(startDate) : startDate;

      // 如果endDate是字符串，则转换为Date对象
      const end = typeof endDate === 'string' ? new Date(endDate) : endDate;

      // 检查当前时间是否在范围内（包含边界）
      return now >= start && now <= end;
    }

  },
};
</script>

<style lang="less" scoped src="./index.less"></style>



